import { Apple, Dumbbell, Wifi, MapPin, ArrowRight } from "lucide-react";
import { openWhatsApp } from "../../lib/whatsapp";

const NUTRITION_IMG =
  "https://images.unsplash.com/photo-1760445529233-ff4bd543270e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwZm9vZCUyMHByZXAlMjBudXRyaXRpb258ZW58MHx8fHwxNzc4MTQ4NzI1fDA&ixlib=rb-4.1.0&q=85";
const TRAINING_IMG =
  "https://images.unsplash.com/photo-1696005264519-4117082d2923?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxtaWRkbGUlMjBhZ2VkJTIwbWFuJTIwZ3ltJTIwdHJhaW5pbmclMjBkYXJrfGVufDB8fHx8MTc3ODE0ODcyNXww&ixlib=rb-4.1.0&q=85";

const services = [
  {
    id: "nutricion",
    icon: Apple,
    title: "Nutrición a medida",
    desc: "Plan de alimentación real, con comidas que disfrutas y se adaptan a tu trabajo, tus viajes y tu familia.",
    bullets: [
      "Sin dietas restrictivas",
      "Comidas reales y flexibles",
      "Estrategias para comer fuera",
    ],
    img: NUTRITION_IMG,
  },
  {
    id: "entrenamiento",
    icon: Dumbbell,
    title: "Entrenamiento eficaz",
    desc: "Rutinas optimizadas para hombres +35 que quieren resultados sin pasar 2 horas al día en el gimnasio.",
    bullets: [
      "Gimnasio o casa",
      "3-4 sesiones por semana",
      "Progresión semanal real",
    ],
    img: TRAINING_IMG,
  },
];

export const Servicios = () => {
  return (
    <section
      id="servicios"
      data-testid="section-servicios"
      className="relative bg-[#0A0A0A] py-24 sm:py-32 border-t border-zinc-900"
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            05 — Servicios
          </p>
          <h2
            data-testid="servicios-heading"
            className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
          >
            Todo lo que necesitas.
            <br />
            <span className="text-[#FF5A1F]">Nada que sobre.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="bg-zinc-950 border border-zinc-800 hover:border-[#FF5A1F]/60 transition-colors flex flex-col"
              >
                <div className="relative h-64 overflow-hidden grain">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                </div>
                <div className="p-8 flex flex-col flex-1">
                  <Icon size={28} className="text-[#FF5A1F]" />
                  <h3 className="font-display uppercase font-black text-2xl sm:text-3xl text-white mt-5 tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-zinc-400 leading-relaxed">{s.desc}</p>
                  <ul className="mt-6 space-y-2">
                    {s.bullets.map((b, i) => (
                      <li
                        key={i}
                        className="flex items-center gap-3 text-zinc-300 text-sm"
                      >
                        <span className="w-1.5 h-1.5 bg-[#FF5A1F]" /> {b}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        {/* Modalidad */}
        <div className="mt-10 grid sm:grid-cols-2 gap-6">
          <div className="bg-zinc-950 border border-zinc-800 p-7 flex items-center gap-5">
            <MapPin size={26} className="text-[#FF5A1F] shrink-0" />
            <div>
              <p className="font-display font-black uppercase text-xl text-white tracking-tight">
                Presencial en Pamplona
              </p>
              <p className="text-sm text-zinc-400 mt-1">
                C/ Berriobide. Sesiones cara a cara, evaluaciones físicas y
                seguimiento personal.
              </p>
            </div>
          </div>
          <div className="bg-zinc-950 border border-zinc-800 p-7 flex items-center gap-5">
            <Wifi size={26} className="text-[#FF5A1F] shrink-0" />
            <div>
              <p className="font-display font-black uppercase text-xl text-white tracking-tight">
                Online con seguimiento
              </p>
              <p className="text-sm text-zinc-400 mt-1">
                App, vídeos y revisiones semanales conmigo. Mismos resultados,
                cero excusas.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex justify-center">
          <button
            data-testid="servicios-cta-whatsapp"
            onClick={() =>
              openWhatsApp(
                "Hola Aitor, quiero saber qué servicio encaja mejor conmigo. CAMBIO"
              )
            }
            className="inline-flex items-center gap-3 bg-[#FF5A1F] hover:bg-[#E04814] transition-colors text-white font-bold uppercase tracking-wider px-8 py-4"
          >
            Pedir información <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
